import * as React from "react";
const MobileWalletContainer = ({
  targetId,
  paymentType,
  checkout,
  mobileWalletConfig,
  children
}) => {
  React.useEffect(() => {
    if (!checkout) {
      return;
    }
    const mountPayment = async () => {
      const c = await checkout;
      const component = c?.create(paymentType, mobileWalletConfig);
      return component.isAvailable().then(() => component?.mount(`#${targetId}`)).catch((error) => {
        console.error(`Mobile wallet for container with id ${targetId} is not available`, error);
      });
    };
    const promise = mountPayment();
    return () => {
      promise.then((component) => component?.unmount());
    };
  }, [mobileWalletConfig, checkout, paymentType, targetId]);
  if (!checkout) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { id: targetId }, children);
};
export {
  MobileWalletContainer
};
//# sourceMappingURL=MobileWalletContainer.js.map
